import { __decorate } from "tslib";
import { Component, Vue, Prop, Model, Watch } from "vue-property-decorator";
import { findComponentsDownward } from "@/common/assist";
let seed = 0;
const now = Date.now();
const getUuid = () => `ivuRadioGroup_${now}_${seed++}`;
let PiRadioGroup = class PiRadioGroup extends Vue {
    constructor() {
        super(...arguments);
        this.children = [];
        this.childSuccess = false;
    }
    "Watch.modelValue"() {
        this.updateValue(this.modelValue);
    }
    /**
     * 改变子级的数据
     */
    updateValue(val) {
        this.$nextTick(() => {
            this.children = findComponentsDownward(this, "PiRadio");
            if (this.children && this.children.length > 0) {
                if (!this.childSuccess) {
                    this.childSuccess = true;
                }
                this.children.forEach((child) => {
                    child.radio = val;
                });
            }
        });
    }
    /**
     * 子级变化
     */
    change(val) {
        this.$emit("value", val);
        this.$emit("on-change", val);
        this.updateValue(val);
    }
    /**
     * 子级加载成功
     */
    childLoadingSuccess() {
        if (!this.childSuccess) {
            this.updateValue(this.modelValue);
        }
    }
    mounted() {
        this.updateValue(this.modelValue);
    }
};
__decorate([
    Prop({ default: false })
], PiRadioGroup.prototype, "disabled", void 0);
__decorate([
    Prop({ default: "" })
], PiRadioGroup.prototype, "type", void 0);
__decorate([
    Prop({ default: getUuid })
], PiRadioGroup.prototype, "name", void 0);
__decorate([
    Watch("modelValue")
], PiRadioGroup.prototype, "Watch.modelValue", null);
__decorate([
    Model("value")
], PiRadioGroup.prototype, "modelValue", void 0);
PiRadioGroup = __decorate([
    Component
], PiRadioGroup);
export default PiRadioGroup;
